import React from 'react';

import Button from '../Button';

import Container from './ErrorBoundayFallback.styled';

export default () => (
  <Container>
    <div className="content center">
      <img src="/assets/img/puzzle-piece.png" alt="error" />
      <h1>Something went wrong...</h1>
      <p>
        Sorry, we ran into a technical issue. The development team has been
        informed about it.
        <br />
        Please reload or try doing something else :)
      </p>
      <Button type="button" styled onClick={() => window.location.reload()}>
        Reload page
      </Button>
      <Button
        type="button"
        styled
        grey
        onClick={() => window.location.assign('/projects')}>
        Go to home
      </Button>
    </div>
  </Container>
);
